var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B3A69B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-273,412.3c-8.4,0-15.2-6.9-15.2-15.3s6.8-15.2,15.2-15.2s15.3,6.8,15.3,15.3 C-257.7,405.4-264.6,412.3-273,412.3z M-273,383.3c-7.6,0-13.7,6.1-13.7,13.7s6.1,13.8,13.7,13.8s13.8-6.2,13.8-13.8 S-265.4,383.3-273,383.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-272.2,403.1h-1.5v-0.3c0-2.2,1.2-4.2,3.1-5.5c1.3-0.8,2.1-2.3,2.1-3.9c0-2.4-2.1-4.4-4.4-4.4c0,0,0,0-0.1,0 c-1.2,0-2.3,0.5-3.2,1.3c-0.9,0.9-1.3,2-1.3,3.2h-1.5c0-1.6,0.6-3.1,1.8-4.3c1.1-1.1,2.6-1.7,4.3-1.7c3.2,0,5.9,2.7,5.9,5.9 c0,2.1-1,4-2.8,5.1c-1.5,1-2.5,2.5-2.5,4.2L-272.2,403.1L-272.2,403.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -273.7,
    y: 404.2,
    className: "st0",
    width: 1.5,
    height: 1.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1d84b871651fbdb623e1cc6fb5b8617e.svg";
export { ForwardRef as ReactComponent };